<template>
  <div class="app-score">
    <p>{{ $translate('score') }}</p>
    <p class="app-score__current-points" v-html="$store.state.score"/>
  </div>
</template>

<script>
export default {
  name: 'AppCurrentScore',
};
</script>

<style lang="scss" scoped>
.app-score {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;

  &__current-points {
    @extend %font-big;
  }
}
</style>
